export default [
  {
    path: "/",
    redirect: "/ofertas",
  },
  {
    path: "/login",
    component: () => import("@/views/Login.vue"),
  },
];
